
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Histogram/index.en.md?watch=parent';
    export const demoIndex = {
  ids: ["histogram-demo-common","histogram-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__Histogram__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Histogram/index.en.md?type=demo')
};